import { graphql } from 'gatsby'
import isNil from 'lodash/isNil'
import React from 'react'

import Button from '@/components/button/button'
import Link from '@/components/link/link'
import { resolveCtaUrl } from '@/internal/utils/resolve-cta-link-url'

export type CtaBlockProps = {
  className?: string
  isBgDark?: boolean
  color?: 'primary' | 'secondary' | 'tertiary'
} & Queries.CtaFragment

export const Cta: React.FC<React.PropsWithChildren<CtaBlockProps>> = (
  props
) => {
  const {
    text,
    linkMedia,
    link,
    linkContent,
    className,
    isBgDark,
    openInNewWindow,
    children,
    color
  } = props
  if (isNil(link) && isNil(linkMedia) && isNil(linkContent)) {
    return null
  }
  const url = resolveCtaUrl(props)
  const colorCta =
    color ??
    (linkContent?.__typename === 'DatoCmsPctTag' ? 'secondary' : 'primary')

  if (children !== null && typeof children !== 'undefined') {
    return (
      <Link
        to={url}
        className={className}
        title={text}
        openInNewWindow={openInNewWindow ?? false}
      >
        {children}
      </Link>
    )
  }

  return (
    <Button
      key={text}
      to={url}
      openNeWindow={openInNewWindow ?? false}
      title={text ?? 'Read more'}
      className={className}
      isBgDark={isBgDark}
      color={colorCta}
    />
  )
}

export default Cta

export const query = graphql`
  fragment Cta on DatoCmsCta {
    originalId: id
    __typename
    text
    ctaType
    linkMedia {
      __typename
      url
    }
    link
    openInNewWindow
    linkContent {
      __typename
      ... on DatoCmsPctDialog {
        slug
      }
      ... on DatoCmsPctPost {
        slug
      }
      ... on DatoCmsPctInterview {
        slug
      }
      ... on DatoCmsPctProject {
        slug
      }
      ... on DatoCmsPctPaper {
        slug
      }
      ... on DatoCmsPctPage {
        slug
      }
      ... on DatoCmsPctInternalPage {
        slug
      }
      ... on DatoCmsPctTopic {
        slug
      }
      ... on DatoCmsPctTag {
        slug
      }
      ... on DatoCmsPctVision {
        slug
      }
      ... on DatoCmsPctReport {
        slug
      }
      ... on DatoCmsPctEpisode {
        slug
      }
      ... on DatoCmsPctLink {
        slug: url
      }
      ... on DatoCmsPctEvent {
        slug
      }
      ... on DatoCmsPctLink {
        ...PctLink
      }
    }
  }
`
